import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components

import BlockWrapper from './BlockWrapper';

// ActionCreators

import { changeData } from '@actions/ssap/ssapActionCreators';


// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';
import { normalizeStringToBooleanValue } from '@utils/normalize/normalizeStringToBooleanValue';
import { getHhmByPersonId } from '@utils/normalize/getHhmByPersonId';
import { convertValuesForReactRender } from '@utils/normalize/convertValuesForReactRender';
import { pick } from '@utils/miscellaneous/objectHelpers';

// Styles

import { darculaTaxesStyles } from '../darculaTheme';

const {
    rowHoverBackground,
    rowDefaultBackground,
    titleStyle,
    primaryTaxFilerRowStyle,
    memberBlockStyle,
    memberHeaderRowStyle,
    memberNameStyle,
    memberMetaPersonIdStyle,
    memberMetaGuidStyle,
    memberMetaHouseholdIdStyle,
    compositionRowStyle,
    compositionLabelStyle,
    compositionValueStyle,
} = darculaTaxesStyles;

const Taxes = ({ id }) => {

    const data = useSelector(state => state.ssap.data);
    const householdMembers = useSelector(state => state.ssap.data.taxHousehold.householdMember);
    const dispatch = useDispatch();

    const {
        taxHousehold: {
            primaryTaxFilerPersonId
        }
    } = data;

    const primaryTaxFiler = primaryTaxFilerPersonId ?
        normalizeNameOfPerson(getHhmByPersonId(primaryTaxFilerPersonId, householdMembers).name) :
        'no Primary Tax Filer';

    const handlePTFClick = () => {

        const newState = { ...data };

        newState
            .taxHousehold
            .primaryTaxFilerPersonId =
            (v => normalizeStringToBooleanValue(v, true))(prompt('Enter new value'));

        dispatch(changeData(newState));
    };

    const handleRowMouseEnter = e => {
        e.currentTarget.style.backgroundColor = rowHoverBackground;
    };

    const handleRowMouseLeave = e => {
        e.currentTarget.style.backgroundColor = rowDefaultBackground;
    };

    return (
        <BlockWrapper id={ id }>
            <div>
                <div style={ titleStyle }>
                    Taxes current status
                </div>
                <div
                    onClick={ handlePTFClick }
                    style={ primaryTaxFilerRowStyle }
                    onMouseEnter={ handleRowMouseEnter }
                    onMouseLeave={ handleRowMouseLeave }
                >
                    { `Primary Tax Filer : ${primaryTaxFiler}` }
                </div>
                {
                    householdMembers.map((hhm, idx) => {
                        const {
                            applicantGuid,
                            householdId,
                            name,
                            personId,
                            taxHouseholdComposition
                        } = hhm;

                        const selectedTaxHouseholdComposition = pick(
                            taxHouseholdComposition,
                            [
                                'taxFilingStatus',
                                'taxRelationship',
                                'claimerIds',
                                'independentTaxFiler',
                                'livesSeparatelyFromClaimerParent',
                                'dependentOnExternalFiler',
                                'claimedByNonCustodialParent',
                                'claimedByOtherThanSpouseOrParent'
                            ]
                        );

                        return (
                            <div
                                key={ `${name}_${idx}` }
                                style={ memberBlockStyle }
                            >
                                <div style={ memberHeaderRowStyle }>
                                    <span style={ memberNameStyle }>{ name ? normalizeNameOfPerson(name) : 'no HM' }</span>
                                    <span style={ memberMetaPersonIdStyle }>{ `Person ID: ${personId}` }</span>
                                    <span style={ memberMetaGuidStyle }>{ `GUID: ${applicantGuid}` }</span>
                                    <span style={ memberMetaHouseholdIdStyle }>{ `Household ID: ${householdId}` }</span>
                                </div>
                                {
                                    Object.entries(selectedTaxHouseholdComposition).map(([ indicator, value ]) => {

                                        return (
                                            <div key={ indicator }>
                                                <div
                                                    style={ compositionRowStyle }
                                                    onMouseEnter={ handleRowMouseEnter }
                                                    onMouseLeave={ handleRowMouseLeave }
                                                >
                                                    <span style={ compositionLabelStyle }>
                                                        { indicator }
                                                    </span>
                                                    <span style={ compositionValueStyle }>
                                                        { convertValuesForReactRender(value) }
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        );
                    })

                }
            </div>
        </BlockWrapper>
    );
};

export default Taxes;
